import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/layout/Layout";
import Home from "@/pages/Home";
import Search from "@/pages/Search";
import MapPage from "@/pages/MapPage";
import States from "@/pages/States";
import StatePage from "@/pages/StatePage";
import CityPage from "@/pages/CityPage";
import CommunityPage from "@/pages/CommunityPage";
import Compare from "@/pages/Compare";
import FeeTrends from "@/pages/FeeTrends";
import Articles from "@/pages/Articles";
import ArticlePage from "@/pages/ArticlePage";
import Contact from "@/pages/Contact";
import SubmitHoa from "@/pages/SubmitHoa";
import HtmlSitemap from "@/pages/HtmlSitemap";
import Legal from "@/pages/Legal";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";

const LEGAL_PAGES = ["privacy-policy", "terms-of-service", "disclaimer", "cookie-policy", "accessibility"];

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="search" element={<Search />} />
              <Route path="map" element={<MapPage />} />
              <Route path="states" element={<States />} />
              <Route path="compare" element={<Compare />} />
              <Route path="fee-trends" element={<FeeTrends />} />
              <Route path="articles" element={<Articles />} />
              <Route path="articles/:slug" element={<ArticlePage />} />
              <Route path="contact" element={<Contact />} />
              <Route path="submit-hoa" element={<SubmitHoa />} />
              <Route path="sitemap" element={<HtmlSitemap />} />
              {LEGAL_PAGES.map((p) => <Route key={p} path={p} element={<Legal page={p} />} />)}
              <Route path="admin/login" element={<AdminLogin />} />
              <Route path="admin" element={<Admin />} />
              <Route path=":state" element={<StatePage />} />
              <Route path=":state/:city" element={<CityPage />} />
              <Route path=":state/:city/:slug" element={<CommunityPage />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
